import { useTranslation } from "react-i18next";

export function FullScreenLoader(): JSX.Element {
  const { t, ready } = useTranslation("common");
  const label = ready ? t("loading") : "Loading…";
  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-screen flex items-center justify-center"
    >
      <span className="text-tg-hint text-sm animate-pulse">{label}</span>
    </div>
  );
}
